import React, { useState } from 'react'

import PropTypes from 'prop-types'

import './roi-button.css'

const ROIButton = (props) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <div className={`roi-button-container ${props.rootClassName} `}>
      {isVisible === false && (
        <p
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          className="formula_button"
        >
          {props.caption11}
        </p>
      )}
      {isVisible === true && (
        <p onMouseLeave={() => setIsVisible(false)} className="formula_button">
          {props.caption1}
        </p>
      )}
    </div>
  )
}

ROIButton.defaultProps = {
  caption11: 'ROI:',
  rootClassName: '',
  caption1: 'Return On Investment:',
}

ROIButton.propTypes = {
  caption11: PropTypes.string,
  rootClassName: PropTypes.string,
  caption1: PropTypes.string,
}

export default ROIButton
